/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modern_Book_ReaderInputs */

const en_modern_book_reader = /** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Book Reader`)
};

const id_modern_book_reader = /** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembaca Buku Modern`)
};

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const es_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const fr_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const de_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const ja_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const zh_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const ar_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const it_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const ru_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const pt_modern_book_reader = en_modern_book_reader;

/** @type {(inputs: Modern_Book_ReaderInputs) => LocalizedString} */
const ko_modern_book_reader = en_modern_book_reader;

/**
* | output |
* | --- |
* | "Modern Book Reader" |
*
* @param {Modern_Book_ReaderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const modern_book_reader = /** @type {((inputs?: Modern_Book_ReaderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modern_Book_ReaderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_modern_book_reader(inputs)
	if (locale === "es") return es_modern_book_reader(inputs)
	if (locale === "fr") return fr_modern_book_reader(inputs)
	if (locale === "de") return de_modern_book_reader(inputs)
	if (locale === "ja") return ja_modern_book_reader(inputs)
	if (locale === "zh") return zh_modern_book_reader(inputs)
	if (locale === "ar") return ar_modern_book_reader(inputs)
	if (locale === "id") return id_modern_book_reader(inputs)
	if (locale === "it") return it_modern_book_reader(inputs)
	if (locale === "ru") return ru_modern_book_reader(inputs)
	if (locale === "pt") return pt_modern_book_reader(inputs)
	return ko_modern_book_reader(inputs)
});